<template>
<v-container fluid  class="weaver-details">
    <v-container class="details-container" style="padding:0px;" >
        <v-layout column style="margin-left:10px;margin-right:10px" >
        <v-layout row style="background:#86af49; border-radius:25px 25px 0px 0px">
         <v-flex grow="1" class="subheading mt-3" style="color:#DDDDDD;padding-left:20px;padding-bottom:5px">10:09 AM</v-flex>      
              <v-layout shrink="1" align-start justify-end row>
                  <v-img position="center center" width="20px" height="20px" src="~@/assets/images/wifi.png" contain="true" style="margin-top:12px;margin-right:5px" />
                  <div class="subheading mt-3" style="text-align: right;color:#DDDDDD;padding-right:2px">57%</div>
                   <v-img position="center center" width="15px" height="20px" src="~@/assets/images/battery.png" contain="true" style="margin-top:12px;margin-right:30px" />    
              </v-layout>               
        </v-layout>
        <v-layout row  style="background:#EEEEEE;height:60px">
        <v-flex>
            <v-img position="center left" width="40px" height="40px" src="~@/assets/images/weaversmall.png" contain="true" style="margin-top:10px;margin-left:20px;float:left" />
             <v-flex class="headline mt-3" style="padding-left:70px;padding-top:10px:font-weight:bold">introductions</v-flex>
        </v-flex>
        <v-img position="center right" width="20px" height="20px" src="~@/assets/images/hamburger.png" contain="true" style="margin-top:20px;margin-right:20px;" />
        </v-layout>
        <v-layout row style="background:#999999;height:2px">
        </v-layout>
        <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Hey, What's the go with this Weaver thing?</v-flex>
         </v-layout>

          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">It's a new social platform allowing anyone, anywhere access to instantaneous communication</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Hmmmn, I noticed I didn't need to sign up. How does that work?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">One of the goals of Weaver is to make it as easy as possible for people to join in on the conversation.</v-flex>
         </v-layout>
                  <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Registration is entirely optional, for those who just want to connect with people it's great.</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">So what happens if I do register?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Registration is for those who want more control.</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You want to create your own private channel where you control who is allowed in?</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You want to inbox other users with private messaging?</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You want to unlock your own unique name?</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Well then Weaver has you covered</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Wait so someone else could have MountainCobbler?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Yep, it's part of it's beauty. No more "this name is already taken" messages.</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Anything the name generator spits out is golden, or just come up with your own</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Awesome, where can I find more info?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px;padding-bottom:20px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">I got you, i'll see you in the FAQ section below</v-flex>
         </v-layout>
        <v-layout row style="background:#999999;height:2px;padding:0px">
        </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:60px; border-radius:0px 0px 25px 25px">
        <v-flex class="headline mt-3" style="padding-left:20px;padding-top:2px">Message...</v-flex>
        <v-flex>
   <v-flex class="headline" style="text-align:center;height:60px;width:150px;color:#DDDDDD;background:#86af49;float:right;padding-top:12px;border-radius:0px 0px 25px 0px">Send</v-flex>
        </v-flex>
     
         </v-layout>
        </v-layout>
    </v-container>
       </v-container>
</template>

<script>
export default {
    name: 'WeaverDetails'
};
</script>

<style scoped>
.weaver-details {
    background: #222222;
    width: 100%;
    
}
.details-container {
    background: #EEEEEE;
    border-radius:25px;
}

</style>